import { isHttpClientError } from 'core/infra/http/HttpClient'
import { ShipperGuideClient } from 'core/infra/http/ShipperGuideClient'

import sentry from 'legacy/utils/sentry'

import type { SubmitBulkSpotQuoteParams } from '../infra/BulkSpotQuoteMapper'
import { SpotQuoteRepository } from '../infra/SpotQuoteRepository'

export type SubmitBulkSpotQuoteFactoryDependencies = {
  spotQuoteRepository: SpotQuoteRepository
}

export function submitBulkSpotQuoteFactory({
  spotQuoteRepository,
}: SubmitBulkSpotQuoteFactoryDependencies) {
  return async function submit(
    params: SubmitBulkSpotQuoteParams,
    config?: { signal?: AbortSignal }
  ) {
    try {
      return await spotQuoteRepository.submitBulkSpotQuote(params, config)
    } catch (error) {
      sentry.log(error)
      let errorMessage = 'There was an error saving the rates'

      if (isHttpClientError(error)) {
        const { detail, non_field_errors: nonFieldErrors } = error.response?.data ?? {}
        errorMessage = detail ?? nonFieldErrors?.[0] ?? errorMessage
      }

      throw new Error(errorMessage, { cause: error as Error })
    }
  }
}

export function submitBulkSpotQuote(
  params: SubmitBulkSpotQuoteParams,
  config?: { signal?: AbortSignal }
) {
  const httpClient = new ShipperGuideClient()
  const spotQuoteRepository = new SpotQuoteRepository({ httpClient })
  const submit = submitBulkSpotQuoteFactory({ spotQuoteRepository })

  return submit(params, config)
}
